import { object, string } from 'yup'

const maskCreditCard = /\d(?=\d{4})/g

export const creditCardSchema = object({
    cardNumber: string()
        .required('Required'),
    expiryDate: string()
        .required('Required'),
    cvv: string()
        .required('Required'),
    cardName: string()
        .required('Required')
})